export default __webpack_public_path__ + "static/media/resumeBuilder.dba200e5.mov";